<template>
    <el-card>
        <el-row class="moneyRisk__title">货币风控配置</el-row>
        
        <!-- 标签页 -->
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
            <el-tab-pane label="风控配置" name="config">
                <!-- 风控配置内容 -->
                <div>
        <!-- 搜索和操作 -->
        <el-row class="moneyRisk__search">
            <div class="item">
                <span>风控名称：</span>
                <el-input v-model="search.monitorName" style="width: 150px" placeholder="请输入风控名称"></el-input>
                <span style="margin-left: 15px;">状态：</span>
                <el-select v-model="search.valid" style="width: 120px" placeholder="请选择状态">
                    <el-option label="全部" :value="null"></el-option>
                    <el-option label="有效" :value="1"></el-option>
                    <el-option label="无效" :value="0"></el-option>
                </el-select>
                <el-button style="margin-left: 10px;" type="primary" @click="getList(1)">搜索</el-button>
                <el-button style="margin-left: 10px;" type="success" @click="showAddDialog">新增配置</el-button>
            </div>
        </el-row>
        <!-- 表格 -->
        <el-table :data="tableList" border>
            <el-table-column prop="id" align="center" label="ID" width="80"></el-table-column>
            <el-table-column prop="monitorName" align="center" label="风控名称"></el-table-column>
            <el-table-column prop="monitorKey" align="center" label="风控Key"></el-table-column>
            <el-table-column prop="additionalValue" align="center" label="B值"></el-table-column>
            <el-table-column prop="actType" align="center" label="变动大类"></el-table-column>
            <el-table-column prop="segCode" align="center" label="变动小类"></el-table-column>
            <el-table-column prop="excludeSegCode" align="center" label="排除变动小类"></el-table-column>
            <el-table-column prop="channelType" align="center" label="渠道" width="100">
                <template slot-scope="scope">
                    {{ scope.row.channelType === 0 ? 'Tikko' : '非Tikko' }}
                </template>
            </el-table-column>
            <el-table-column prop="valid" align="center" label="状态" width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.valid === 1 ? 'success' : 'danger'">
                        {{ scope.row.valid === 1 ? '有效' : '无效' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="operator" align="center" label="操作人"></el-table-column>
            <el-table-column prop="ctime" align="center" label="创建时间" width="160">
                <template slot-scope="scope">
                    {{ formatDate(scope.row.ctime) }}
                </template>
            </el-table-column>
            <el-table-column prop="mtime" align="center" label="修改时间" width="160">
                <template slot-scope="scope">
                    {{ formatDate(scope.row.mtime) }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
                    <el-button 
                        :type="scope.row.valid === 1 ? 'danger' : 'success'" 
                        size="mini"
                        @click="handleToggleStatus(scope.row)"
                    >
                        {{ scope.row.valid === 1 ? '禁用' : '启用' }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row>
            <el-pagination 
                background 
                layout="prev, pager, next" 
                :total="total" 
                :page-size="pageSize"
                :current-page.sync="currentPage" 
                @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>

        <!-- 新增/编辑对话框 -->
        <el-dialog 
            :title="dialogTitle" 
            :visible.sync="dialogVisible" 
            width="600px"
        >
            <el-form :model="form" :rules="rules" ref="form" label-width="120px">
                <el-form-item label="风控名称" prop="monitorName">
                    <el-input v-model="form.monitorName" placeholder="请输入风控名称"></el-input>
                </el-form-item>
                <el-form-item label="风控Key" prop="monitorKey">
                    <el-input v-model="form.monitorKey" placeholder="请输入风控Key"></el-input>
                </el-form-item>
                <el-form-item label="B值" prop="additionalValue">
                    <el-input v-model="form.additionalValue" placeholder="请输入B值"></el-input>
                </el-form-item>
                <el-form-item label="变动大类" prop="actType">
                    <div class="tag-manager">
                        <el-tag 
                            v-for="(tag, index) in form.actTypeList" 
                            :key="index" 
                            closable 
                            @close="removeTag('actType', index)"
                            style="margin-right: 5px; margin-bottom: 5px;"
                        >
                            {{ tag }}
                        </el-tag>
                        <el-button type="primary" size="mini" @click="showTagManager('actType')">管理标签</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="变动小类" prop="segCode">
                    <div class="tag-manager">
                        <el-tag 
                            v-for="(tag, index) in form.segCodeList" 
                            :key="index" 
                            closable 
                            @close="removeTag('segCode', index)"
                            style="margin-right: 5px; margin-bottom: 5px;"
                        >
                            {{ tag }}
                        </el-tag>
                        <el-button type="primary" size="mini" @click="showTagManager('segCode')">管理标签</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="排除变动小类" prop="excludeSegCode">
                    <div class="tag-manager">
                        <el-tag 
                            v-for="(tag, index) in form.excludeSegCodeList" 
                            :key="index" 
                            closable 
                            @close="removeTag('excludeSegCode', index)"
                            style="margin-right: 5px; margin-bottom: 5px;"
                        >
                            {{ tag }}
                        </el-tag>
                        <el-button type="primary" size="mini" @click="showTagManager('excludeSegCode')">管理标签</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="渠道" prop="channelType" v-if="!isEdit">
                    <el-select v-model="form.channelType" placeholder="请选择渠道">
                        <el-option label="Tikko" :value="0"></el-option>
                        <el-option label="非Tikko" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="valid">
                    <el-radio-group v-model="form.valid">
                        <el-radio :label="1">有效</el-radio>
                        <el-radio :label="0">无效</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </div>
        </el-dialog>

        <!-- 标签管理弹窗 -->
        <el-dialog title="标签管理" :visible.sync="tagManagerVisible" width="600px">
            <div class="tag-manager-dialog">
                <div class="tag-input-section">
                    <h4>添加标签</h4>
                    <el-input 
                        v-model="newTag" 
                        placeholder="请输入单个标签"
                        style="width: 200px; margin-right: 10px;"
                        @keyup.enter.native="addSingleTag"
                    ></el-input>
                    <el-button type="primary" @click="addSingleTag">添加</el-button>
                </div>
                
                <div class="tag-batch-section">
                    <h4>批量添加</h4>
                    <el-input 
                        v-model="batchTags" 
                        type="textarea" 
                        placeholder="请输入多个标签，用英文逗号分隔"
                        :rows="3"
                        style="margin-bottom: 10px;"
                    ></el-input>
                    <el-button type="success" @click="addBatchTags">批量添加</el-button>
                </div>

                <div class="tag-list-section">
                    <div class="tag-list-header">
                        <h4>标签列表 ({{ currentTagList.length }})</h4>
                        <div>
                            <el-button type="danger" size="mini" @click="clearAllTags">清空</el-button>
                        </div>
                    </div>
                    <div class="tag-list">
                        <el-tag 
                            v-for="(tag, index) in currentTagList" 
                            :key="index" 
                            closable 
                            @close="removeTagFromList(index)"
                            style="margin-right: 5px; margin-bottom: 5px;"
                        >
                            {{ tag }}
                        </el-tag>
                        <div v-if="currentTagList.length === 0" class="empty-tags">
                            暂无标签
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="tagManagerVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmTagManager">确定</el-button>
            </div>
        </el-dialog>
                </div>
            </el-tab-pane>
            
            <el-tab-pane label="触发记录" name="trigger">
                <!-- 触发记录内容 -->
                <div>
                    <!-- 触发记录搜索 -->
                    <el-row class="moneyRisk__search">
                        <div class="item">
                            <span>状态：</span>
                            <el-select v-model="triggerSearch.valid" style="width: 120px" placeholder="请选择状态">
                                <el-option label="全部" :value="null"></el-option>
                                <el-option label="有效" :value="1"></el-option>
                                <el-option label="无效" :value="0"></el-option>
                            </el-select>
                            <el-button style="margin-left: 10px;" type="primary" @click="getTriggerList(1)">搜索</el-button>
                        </div>
                    </el-row>
                    
                    <!-- 触发记录表格 -->
                    <el-table :data="triggerTableList" border>
                        <el-table-column prop="id" align="center" label="ID" width="80"></el-table-column>
                        <el-table-column prop="date" align="center" label="日期" width="120"></el-table-column>
                        <el-table-column prop="monitorName" align="center" label="风控名称"></el-table-column>
                        <el-table-column prop="level" align="center" label="告警级别" width="100"></el-table-column>
                        <el-table-column prop="threshold" align="center" label="阈值"></el-table-column>
                        <el-table-column prop="mean" align="center" label="均值"></el-table-column>
                        <el-table-column prop="standardDeviation" align="center" label="标准差"></el-table-column>
                        <el-table-column prop="additionalValue" align="center" label="额外兜底值"></el-table-column>
                        <el-table-column prop="operator" align="center" label="操作人"></el-table-column>
                        <el-table-column prop="valid" align="center" label="状态" width="100">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.valid === 1 ? 'success' : 'danger'">
                                    {{ scope.row.valid === 1 ? '有效' : '无效' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button 
                                    :type="scope.row.valid === 1 ? 'danger' : 'success'" 
                                    size="mini"
                                    @click="handleTriggerToggleStatus(scope.row)"
                                >
                                    {{ scope.row.valid === 1 ? '禁用' : '启用' }}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    
                    <!-- 触发记录分页 -->
                    <el-row>
                        <el-pagination 
                            background 
                            layout="prev, pager, next" 
                            :total="triggerTotal" 
                            :page-size="triggerPageSize"
                            :current-page.sync="triggerCurrentPage" 
                            @current-change="handleTriggerCurrentChange">
                        </el-pagination>
                    </el-row>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            activeTab: 'config',
            search: {
                monitorName: null,
                valid: null
            },
            tableList: [],
            total: 0,
            currentPage: 1,
            pageSize: 20,
            dialogVisible: false,
            dialogTitle: '新增配置',
            isEdit: false,
            form: {
                id: null,
                monitorName: '',
                monitorKey: '',
                additionalValue: '',
                actType: '',
                segCode: '',
                excludeSegCode: '',
                channelType: 0,
                valid: 1,
                // 标签列表
                actTypeList: [],
                segCodeList: [],
                excludeSegCodeList: []
            },
            rules: {
                monitorName: [
                    { required: true, message: '请输入风控名称', trigger: 'blur' }
                ],
                monitorKey: [
                    { required: true, message: '请输入风控Key', trigger: 'blur' }
                ],
                additionalValue: [
                    { required: true, message: '请输入B值', trigger: 'blur' }
                ],
                channelType: [
                    { required: true, message: '请选择渠道', trigger: 'change' }
                ]
            },
            // 触发记录相关数据
            triggerSearch: {
                valid: null
            },
            triggerTableList: [],
            triggerTotal: 0,
            triggerCurrentPage: 1,
            triggerPageSize: 20,
            // 标签管理相关数据
            tagManagerVisible: false,
            currentTagType: '', // 当前编辑的标签类型
            currentTagList: [], // 当前标签列表
            newTag: '', // 新标签输入
            batchTags: '' // 批量标签输入
        }
    },
    created() {
        this.getList()
    },
    methods: {
        showAddDialog() {
            this.isEdit = false
            this.dialogTitle = '新增配置'
            this.form = {
                id: null,
                monitorName: '',
                monitorKey: '',
                additionalValue: '',
                actType: '',
                segCode: '',
                excludeSegCode: '',
                channelType: 0,
                valid: 1,
                actTypeList: [],
                segCodeList: [],
                excludeSegCodeList: []
            }
            this.dialogVisible = true
        },
        showEditDialog(row) {
            this.isEdit = true
            this.dialogTitle = '编辑配置'
            this.form = { 
                ...row,
                actTypeList: row.actType ? row.actType.split(',').filter(item => item.trim()) : [],
                segCodeList: row.segCode ? row.segCode.split(',').filter(item => item.trim()) : [],
                excludeSegCodeList: row.excludeSegCode ? row.excludeSegCode.split(',').filter(item => item.trim()) : []
            }
            this.dialogVisible = true
        },
        async submitForm() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        const url = this.isEdit ? 
                            this.$store.getters.path.money_risk_update : 
                            this.$store.getters.path.money_risk_add
                        
                        // 将标签列表转换为逗号分隔的字符串
                        const submitData = {
                            ...this.form,
                            actType: this.form.actTypeList.join(','),
                            segCode: this.form.segCodeList.join(','),
                            excludeSegCode: this.form.excludeSegCodeList.join(',')
                        }
                        
                        const { data: res } = await this.$axios({
                            method: 'post',
                            url: url,
                            params: {
                                username: this.$store.getters.username,
                                token: this.$store.getters.token,
                            },
                            data: submitData,
                        })
                        
                        if (res.code === 0) {
                            this.$message.success(this.isEdit ? '修改成功' : '添加成功')
                            this.dialogVisible = false
                            this.getList()
                        } else {
                            this.$message.error(res.msg || '操作失败')
                        }
                    } catch (error) {
                        this.$message.error('操作失败')
                    }
                }
            })
        },
        handleToggleStatus(row) {
            const action = row.valid === 1 ? '禁用' : '启用'
            this.$confirm(`确定${action}该配置吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.toggleStatus(row.id, row.valid === 1 ? 0 : 1)
            })
        },
        async toggleStatus(id, valid) {
            try {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.money_risk_update,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    },
                    data: {
                        id,
                        valid,
                    },
                })
                if (res.code === 0) {
                    this.$message.success('操作成功')
                    this.getList()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            } catch (error) {
                this.$message.error('操作失败')
            }
        },
        guaranteedHandleCurrentChange(page) {
            this.getList(page)
        },
        // 格式化时间
        formatDate(timestamp) {
            if (!timestamp) return '-'
            const date = new Date(timestamp * 1000)
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            })
        },
        // 获取数据列表
        async getList(page) {
            if (page) {
                this.currentPage = page
            }
            try {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.money_risk_query,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    },
                    data: {
                        ...this.search,
                        page: this.currentPage,
                    },
                })
                if (res.code === 0) {
                    this.tableList = res.data.data
                    this.total = res.data.total
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            } catch (error) {
                this.$message.error('获取数据失败')
            }
        },
        // 标签页切换
        handleTabClick(tab) {
            if (tab.name === 'trigger') {
                this.getTriggerList()
            }
        },
        // 获取触发记录列表
        async getTriggerList(page) {
            if (page) {
                this.triggerCurrentPage = page
            }
            try {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.money_risk_trigger_record,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    },
                    data: {
                        ...this.triggerSearch,
                        page: this.triggerCurrentPage,
                    },
                })
                if (res.code === 0) {
                    this.triggerTableList = res.data.data
                    this.triggerTotal = res.data.total
                } else {
                    this.$message.error(res.msg || '获取触发记录失败')
                }
            } catch (error) {
                this.$message.error('获取触发记录失败')
            }
        },
        // 触发记录状态切换
        handleTriggerToggleStatus(row) {
            const action = row.valid === 1 ? '禁用' : '启用'
            this.$confirm(`确定${action}该触发记录吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.toggleTriggerStatus(row.id, row.valid === 1 ? 0 : 1)
            })
        },
        // 切换触发记录状态
        async toggleTriggerStatus(id, valid) {
            try {
                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.money_risk_trigger_valid_change,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    },
                    data: {
                        id,
                        valid,
                    },
                })
                if (res.code === 0) {
                    this.$message.success('操作成功')
                    this.getTriggerList()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            } catch (error) {
                this.$message.error('操作失败')
            }
        },
        // 触发记录分页
        handleTriggerCurrentChange(page) {
            this.getTriggerList(page)
        },
        // 标签管理相关方法
        showTagManager(tagType) {
            this.currentTagType = tagType
            this.currentTagList = [...this.form[`${tagType}List`]]
            this.newTag = ''
            this.batchTags = ''
            this.tagManagerVisible = true
        },
        addSingleTag() {
            if (this.newTag.trim()) {
                if (!this.currentTagList.includes(this.newTag.trim())) {
                    this.currentTagList.push(this.newTag.trim())
                    this.newTag = ''
                } else {
                    this.$message.warning('标签已存在')
                }
            }
        },
        addBatchTags() {
            if (this.batchTags.trim()) {
                const tags = this.batchTags.split(',').map(tag => tag.trim()).filter(tag => tag)
                // 先对输入中的标签去重
                const uniqueTags = [...new Set(tags)]
                // 再过滤与现有标签的重复
                const newTags = uniqueTags.filter(tag => !this.currentTagList.includes(tag))
                this.currentTagList.push(...newTags)
                this.batchTags = ''
                
                const inputDuplicates = tags.length - uniqueTags.length
                const existingDuplicates = uniqueTags.length - newTags.length
                const totalFiltered = inputDuplicates + existingDuplicates
                
                if (totalFiltered > 0) {
                    let message = `已过滤 ${totalFiltered} 个重复标签`
                    if (inputDuplicates > 0 && existingDuplicates > 0) {
                        message += `（输入中重复 ${inputDuplicates} 个，与现有重复 ${existingDuplicates} 个）`
                    } else if (inputDuplicates > 0) {
                        message += `（输入中重复 ${inputDuplicates} 个）`
                    } else if (existingDuplicates > 0) {
                        message += `（与现有重复 ${existingDuplicates} 个）`
                    }
                    this.$message.warning(message)
                }
            }
        },
        removeTagFromList(index) {
            this.currentTagList.splice(index, 1)
        },
        removeTag(tagType, index) {
            this.form[`${tagType}List`].splice(index, 1)
        },
        clearAllTags() {
            this.$confirm('确定要清空所有标签吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.currentTagList = []
                this.$message.success('已清空所有标签')
            })
        },
        confirmTagManager() {
            this.form[`${this.currentTagType}List`] = [...this.currentTagList]
            this.tagManagerVisible = false
        },
        
        // 取消编辑
        handleCancel() {
            this.dialogVisible = false
        }
    }
}
</script>
<style scoped lang="scss">
.moneyRisk {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-bottom: 20px;

        span {
            font-size: 16px;
            font-weight: 600;
            margin-right: 10px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}

.dialog-footer {
    text-align: right;
}

.tag-manager {
    .el-tag {
        margin-right: 5px;
        margin-bottom: 5px;
    }
}

.tag-manager-dialog {
    .tag-input-section,
    .tag-batch-section,
    .tag-list-section {
        margin-bottom: 20px;
        
        h4 {
            margin-bottom: 10px;
            color: #606266;
            font-size: 14px;
        }
    }
    
    .tag-list-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        
        h4 {
            margin: 0;
        }
    }
    
    .tag-list {
        min-height: 60px;
        padding: 10px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        background-color: #fafafa;
        
        .empty-tags {
            color: #909399;
            text-align: center;
            line-height: 40px;
        }
    }
}
</style>
